import { render } from "./VkAuthButton.vue?vue&type=template&id=ccd2d42c&scoped=true"
import script from "./VkAuthButton.vue?vue&type=script&lang=js"
export * from "./VkAuthButton.vue?vue&type=script&lang=js"

import "./VkAuthButton.vue?vue&type=style&index=0&id=ccd2d42c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd2d42c"]])

export default __exports__